module.exports = __webpack_public_path__ + "img/65.9360b67d.png";